/** View model used by Aggregation UI. */
export interface AggregationMetrics {
  aum: number;
  subfundCount: number;
}

export interface RegulationBucketAggregation extends AggregationMetrics {
  regulationBucket: string;
  regulationBucketKey: string;
}

export interface MancoAggregation extends AggregationMetrics {
  mancoId: string;
  mancoName: string;
  byRegulationBucket: RegulationBucketAggregation[];
}

export interface AggregationData {
  baseCurrency: string;
  regulationBucketOrder: string[];
  group: AggregationMetrics & {
    byRegulationBucket: RegulationBucketAggregation[];
  };
  mancos: MancoAggregation[];
}

/** Raw GET /aggregation payload (HG MACRO route). */
interface MacroAggregationBucketRow {
  regulation_bucket?: string;
  name?: string;
  aum?: number;
  subfunds?: number;
}

interface MacroAggregationMancoRow {
  client_id?: string;
  name?: string;
  aum?: number;
  subfunds?: number;
  by_regulation_bucket?: MacroAggregationBucketRow[];
}

interface MacroAggregationResponse {
  base_currency?: string;
  regulation_bucket_order?: string[];
  group_total?: {
    name?: string;
    aum?: number;
    subfunds?: number;
  };
  by_regulation_bucket?: MacroAggregationBucketRow[];
  by_manco?: MacroAggregationMancoRow[];
}

const mapBucket = (
  row: MacroAggregationBucketRow,
): RegulationBucketAggregation => ({
  regulationBucketKey: row.regulation_bucket ?? '',
  regulationBucket: row.name ?? row.regulation_bucket ?? '',
  aum: row.aum ?? 0,
  subfundCount: row.subfunds ?? 0,
});

export const mapMacroAggregationResponse = (
  response: unknown,
): AggregationData => {
  const data = (response ?? {}) as MacroAggregationResponse;
  const groupTotal = data.group_total ?? {};

  return {
    baseCurrency: data.base_currency || 'EUR',
    regulationBucketOrder: data.regulation_bucket_order ?? [],
    group: {
      aum: groupTotal.aum ?? 0,
      subfundCount: groupTotal.subfunds ?? 0,
      byRegulationBucket: (data.by_regulation_bucket ?? []).map(mapBucket),
    },
    mancos: (data.by_manco ?? []).map((manco) => ({
      mancoId: manco.client_id ?? '',
      mancoName: manco.name ?? '',
      aum: manco.aum ?? 0,
      subfundCount: manco.subfunds ?? 0,
      byRegulationBucket: (manco.by_regulation_bucket ?? []).map(mapBucket),
    })),
  };
};
